import { polyfill } from 'smoothscroll-polyfill';

if (process.browser) {
  polyfill();
}
